<script>
  import Modal from './Modal.svelte';
  import YouTubeModal from './YouTubeModal.svelte';
  export let isHomeScreen = false;
  export let isDarkMode = false;
  const handleHover = (event) => {
    const description = event.target.nextElementSibling;
    description.style.display = 'block';
  };
  
  const handleLeave = (event) => {
    const description = event.target.nextElementSibling;
    description.style.display = 'none';
  };

  let showVideoModal = false;
  let videoUrl = '/video/benbanker-book.mp4';
  let showYouTubeModal = false;
  let videos = [
{
      id: 'qbBCoVpMm-w',
      title: '1'
    },
{
      id: 'yVceK6EZ4pI',
      title: '2'
    },
{
      id: 'L5N2d2U0i90',
      title: '3'
    },
{
      id: '3K4JUJXq4y0',
      title: '9 hour'
    },
{
      id: 'g1upozzan14',
      title: 'Glitch'
    },
{
      id: 'uqoSR7VRPW8',
      title: 'Art Video'
    },
    {
      id: 'IhDGzNtpfiM',
      title: 'Book Video'
    }
  ];
</script>

<main>
  <div class="sidebar-container {isDarkMode ? 'dark-mode' : ''}">
    <div class="sidebar">
      <div class="book-link">
        <a href="/books/book_ben-banker_woodblock-2nd-edition.pdf"
          on:mouseover={handleHover}
          on:mouseleave={handleLeave}
        >Free<br> Book<br> PDF</a>
        <div class="description">This is a free book in PDF format. Click the link to download.</div>
      </div>

      <div class="video-link">
        <button on:click={() => showVideoModal = true}>Watch <br> video</button>
      </div>

<div class="youtube-link">
  <div class="youtube-container">
    <button class="youtube-button" on:click={() => showYouTubeModal = true}>
      <img src="/images/youtube-vector-logo-png-9.png" alt="YouTube Logo" width="43" height="43">
    </button>
    {#if showYouTubeModal}
      <div class="sidenav">
      </div>
      <YouTubeModal videos={videos} isDarkMode={isDarkMode} onClose={() => showYouTubeModal = false} />
    {/if}
  </div>
</div>
      
      
    </div>
  </div>

  {#if showVideoModal}
    <Modal videoUrl={videoUrl} onClose={() => showVideoModal = false} />
  {/if}

</main>
